import React, {useContext, useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {Navbar} from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import {Link} from 'react-router-dom';
import Account from "./Account";
import {ContractsContext, Web3Context} from "../../contexts/Context";

import '../../styles/NavBar.css';

const NavBar = () => {
  const web3Context = useContext(Web3Context);
  const contractsContext = useContext(ContractsContext);

  const {web3, activeAccount} = web3Context;
  const {contractNiftyEggsERC20} = contractsContext;

  const [activeLink, setActiveLink] = useState("/");
  const location = useLocation();
  useEffect(() => {
    const currentPath = location.pathname;
    setActiveLink(currentPath);

    const hash = location.hash;
    if (!hash) return;
    setTimeout(() => {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) element.scrollIntoView();
    }, 300);
  }, [location]);

  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="container-fluid header-nav">
      <div className="row no-gutters">
          <div className="col-12 col-md-10 offset-md-1">
            <Navbar expand="lg" className="py-0" expanded={isExpanded}>
              <Link className="navbar-brand" to="/">NiftyEggs.<span>eth</span></Link>
              <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setIsExpanded(isExpanded ? false : "expanded")}/>
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ml-auto" activeKey={activeLink}>
                  <Nav.Item>
                    <Nav.Link eventKey="/" className="nav-link py-4" as={Link} to="/" onClick={() => setIsExpanded(false)}>Home</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="/inventory" className="nav-link py-4" as={Link} to="/inventory" onClick={() => setIsExpanded(false)}>NiftyEggs</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="/events" className="nav-link py-4" as={Link} to="/events" onClick={() => setIsExpanded(false)}>Events</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <span className="disabled-tooltip" tabIndex="0" data-toggle="tooltip" title="Coming soon...">
                      <Nav.Link eventKey="disabled" disabled className="nav-link py-4" href="https://opensea.io/" target="_blank" rel="noopener noreferrer">
                        Marketplace
                      </Nav.Link>
                    </span>
                  </Nav.Item>
                  <Nav.Item className="my-lg-auto mb-3 ml-lg-3 mr-lg-3">
                    <Nav.Link eventKey="/farm" className="btn btn-primary btn-scale text-white px-3" as={Link} to="/farm" onClick={() => setIsExpanded(false)}>Farm</Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="my-lg-auto mb-3">
                    <Nav.Link eventKey="/create" className="btn btn-primary btn-scale text-white" as={Link} to="/create" onClick={() => setIsExpanded(false)}>Create</Nav.Link>
                  </Nav.Item>
                  {
                    web3 && activeAccount && contractNiftyEggsERC20 ?
                      <Account/>
                      :
                      null
                  }
                </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </div>
    </div>
  );
};

export default NavBar;